export default "__VITE_ASSET__irmCGUEj__"